// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".single-value{text-align:center;display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%}.single-value__value{font-size:4.5rem;font-weight:600}.single-value__title{font-size:1.6rem;font-weight:600;opacity:0.6}\n", ""]);
// Exports
module.exports = exports;
